import React from "react";

const commonChecklistContent = [
  "Invoices, receipts or bills for your treatment",
  "Your condition and treatment details",
  "Specialist or healthcare provider details (if you have them)"
];

const MedicalTreatment = {
  checklistText: (
    <React.Fragment>
      <p>Please have the following ready for your claim submission:</p>
    </React.Fragment>
  ),
  newClaimChecklist: ["GP open referral letter", ...commonChecklistContent],
  existingClaimChecklist: commonChecklistContent,
  checklistSLA:
    "If you're uploading invoices that you've already paid, please clearly mark on the documents that you've done so. Once you've submitted your documents, please allow up to 10 working days for us to review them.",
  infoBoxIconClass: "icon-help-outline"
};

export default MedicalTreatment;
